import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthenticationApiService } from '../authentication-api.service';

export const authenticationGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
    const authenticationApiService = inject(AuthenticationApiService);

    return authenticationApiService.currentAuthenticationState$.pipe(
        // AUTH IS STILL INITIALIZING, KEEP WAITING
        // USER NOT LOADED, KEEP WAITING
        filter(authenticationState => authenticationState !== 'initializing' && authenticationState !== 'userLoading'),
        map(currentAuthenticationState => {
            // NOT LOGGED IN, START AUTHENTICATION AND WAIT FOR NEXT RUN
            if (currentAuthenticationState === 'unauthenticated') {
                void authenticationApiService.login(state.url);
                return false;
            }

            // USER ERROR, RETURN FALSE
            if (currentAuthenticationState === 'userError') {
                return false;
            }

            // AUTHENTICATED - USER LOADED
            return true;
        }),
    );
};
